import React from 'react';

export default function AddIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="ic_btn_add"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <path
        d="M4 12H20"
        stroke={props.stroke ?? 'currentColor'}
        strokeWidth={props.strokeWidth ?? '1.8'}
        stroke-linecap="round"
      />
      <path
        d="M12 4L12 20"
        stroke={props.stroke ?? 'currentColor'}
        strokeWidth={props.strokeWidth ?? '1.8'}
        stroke-linecap="round"
      />
    </svg>
  );
}
